import { useState } from "react";
import { useSelector } from "react-redux";

import { filterFormFields } from "./product-filter-form-fields";

import FormFactory from "../../../../components/FormFactory";
import FilterHeader from "../../../../components/HexFilters/FilterHeader";
import FilterFooterButton from "../../../../components/HexFilters/FilterFooterButton";
import { getSubmissionData } from "../../../Registration/hooks/use-helpers";

import { defaultProductFilters } from "../product-view-utils";
import { radiusInMeters } from "../../../../utils/constants";
import "./style.css";

const ProductFilters = ({ filterParams, onSave, accessoryProps }) => {
  const { containerTypes, fuelTypes, containerOptions } = useSelector(
    (state) => state.publicAPIs
  );

  const filterProps = {
    fuelTypes,
    containerTypes,
    containerOptions,
    accessoryProps,
    paramValues: filterParams,
  };

  const [formFields, setFormFields] = useState(filterFormFields(filterProps));

  const [errors, setErrors] = useState({});

  const onResetFilter = () => {
    setFormFields(filterFormFields(filterProps));

    setErrors({});

    let filterData = defaultProductFilters;

    if (accessoryProps) {
      filterData = {
        ...filterData,
        "location.distanceMeters": radiusInMeters,
      };
    }
    onSave(filterData);
  };

  const onFieldChange = (value, key) => {
    const filterFields = { ...formFields };
    const fieldErrors = { ...errors };
    filterFields[key].value = value;

    fieldErrors[key] && delete fieldErrors[key];

    setFormFields(filterFields);
    setErrors(fieldErrors);
  };

  const renderFields = (fields) => {
    return Object.keys(fields).map((fieldKey, index) => {
      const { elementConfigs, hiddenField } = fields[fieldKey];
      if (hiddenField) return null;
      return (
        <div className="filter-field-item" key={index}>
          <div className="font-16-normal-400 field-item-label">
            {elementConfigs.filterFieldLabel}
          </div>

          <FormFactory
            formElementsTypes={{ [fieldKey]: fields[fieldKey] }}
            onChangeHandler={(value, key) => onFieldChange(value, key)}
            errors={errors}
          />
        </div>
      );
    });
  };

  const onSubmit = () => {
    const { required, fieldData } = getSubmissionData(formFields);

    if (Object.keys(required).length) {
      setErrors(required);
    } else {
      const {
        price,
        radius,
        fuelTypeId,
        containerVolume,
        containerTypeId,
        containerMaterialId,
      } = fieldData;

      const filterData = {
        ...(containerTypeId.length && {
          containerTypeId,
        }),

        ...(fuelTypeId.length && {
          fuelTypeId,
        }),

        ...(containerMaterialId &&
          containerMaterialId.length && {
            containerMaterialId,
          }),

        minVolume: containerVolume[0],
        maxVolume: containerVolume[1],

        minPrice: price[0],
        maxPrice: price[1],
        ...(radius && { "location.distanceMeters": radius[1] * 1000 }),
      };

      onSave(filterData);
    }
  };

  return (
    <div>
      <FilterHeader onClear={onResetFilter} />
      <div className="regular-filter-form">{renderFields(formFields)}</div>
      <FilterFooterButton onClick={onSubmit} />
    </div>
  );
};

export default ProductFilters;
